import { z } from "zod";

export const getCostCenterParamsSchema = z.object({
	costCenterId: z.uuid(),
});

export type GetCostCenterParamsSchema = z.infer<typeof getCostCenterParamsSchema>;
